
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/reported-speech-explanation';
const mainimage = '/Images/reportedspeech1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "reportedspeech" },
];

const ReportedSpeech = () => (
  <GrammarPageLayout
    level="B2"
    title="Reported Speech"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Reported Speech Exercises"
    seoDescription="Transform direct speech into reported speech with tense changes. B2 level advanced practice."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);

export default ReportedSpeech;

